import { render, staticRenderFns } from "./menopausejkfa.vue?vue&type=template&id=7d87bc41&scoped=true&"
import script from "./menopausejkfa.vue?vue&type=script&lang=js&"
export * from "./menopausejkfa.vue?vue&type=script&lang=js&"
import style0 from "./menopausejkfa.vue?vue&type=style&index=0&id=7d87bc41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d87bc41",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d87bc41')) {
      api.createRecord('7d87bc41', component.options)
    } else {
      api.reload('7d87bc41', component.options)
    }
    module.hot.accept("./menopausejkfa.vue?vue&type=template&id=7d87bc41&scoped=true&", function () {
      api.rerender('7d87bc41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menopauseovary/components/menopausejkfa.vue"
export default component.exports